import { render } from "./JobItemsPanel.vue?vue&type=template&id=0274ffdc&scoped=true"
import script from "./JobItemsPanel.vue?vue&type=script&lang=js"
export * from "./JobItemsPanel.vue?vue&type=script&lang=js"

import "./JobItemsPanel.vue?vue&type=style&index=0&id=0274ffdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0274ffdc"]])

export default __exports__